import { FusePageCarded } from "@fuse";
import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import AgendamentoEdicaoApp from "app/CRM/AgendamentoEdicao/AgendamentoEdicaoApp";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import Cronometro from "app/Core/Components/Cronometro/Cronometro";
import CustomCrmForm from "app/Core/Components/CustomCrmForm/CustomCrmForm";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import DocumentoAtendimento from "app/Core/Components/DocumentoAtendimento/DocumentoAtendimento";
import Memed from "app/Core/Components/Memed/Memed";
import MensagemAgendamento from "app/Core/Components/Mensagem/MensagemAgendamento";
import { disableScreenLock } from "app/Core/Components/ScreenLock/Store/Actions/ScreenLockActions";
import TagFormulario from "app/Core/Components/TagFormulario/TagFormulario";
import WebexMeeting from "app/Core/Components/Webex/WebexMeeting";
import WebexMeetingToogle from "app/Core/Components/Webex/WebexMeetingToogle";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import EmpresaPessoaFormularioApp from "app/ERP/EmpresaPessoaFormulario/EmpresaPessoaFormularioApp";
import ArquivoApp from "app/GED/Arquivo/ArquivoApp";
import GaleriaApp from "app/GED/Galeria/GaleriaApp";
import GerenciadorProcessoApp from "app/Workflow/GerenciadorProcesso/GerenciadorProcessoApp";
import TarefaApontamentoPedidoEmAberto from "app/Workflow/TarefaApontamento/TarefaApontamentoPedidoEmAberto";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";
import Draggable from "react-draggable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import CompartilharDocumentos from "../../Components/CompartilharDocumentos/CompartilharDocumentos";
import * as Actions from "../../Store/Actions/MinhasTarefasActions";
import AtendimentoNavbar from "./AtendimentoNavbar";

const md = new MobileDetect(window.navigator.userAgent);

const styles = (theme) => ({
   toolbarPessoa: {
      height: "fit-content",
      minHeight: "auto",
   },
   paper: {
      border: "1px solid " + theme.palette.divider,
      //marginBottom: "24px",
      padding: "4px",
   },
   spanlabel: {
      top: 9,
      left: 15,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      paddingRight: 5,
      paddingLeft: 5,
      fontSize: 12.5,
      fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
      color: theme.palette.text.secondary,
      maxWidth: "140px",
   },
   toolbarDialog: {
      background: "linear-gradient(to right, " + theme.palette.primary.dark + " 0%, " + theme.palette.primary.main + " 100%)",
      minHeight: "32px !important",
   },
   chipTela: {
      backgroundColor: theme.palette.primary.dark,
      color: "#fff !important",
   },
   topBg: {
      background: theme.palette.background.paper,
   },
   meeting: {
      "@media (max-width: 600px)": {
         transform: "none !important",
         marginBottom: 8
      },
   },
});

const newTarefaState = {
   idtarefa: null,
   titulo: null,
   tipo: null,
   descricao: null,
   idfluxo: null,
   tabsdialog: null,
   apontamento: null,
   observacao: null,
   fluxo: "{}",
   formulario: {},
   pessoaformulario: {},
};

const state = {
   form: { ...newTarefaState },
   tabValue: 0,
   value: 0,
   showNavbar: true,
   showAllDados: true
};

class AtendimentoDialog extends XAPPComponent {

   state = { ...state };

   componentDidMount() {
      this.props.clearAtendimentos();
      this.props.disableScreenLock(true);
      var obj = null;
      var AState = {};
      if (this.props.open !== null && this.props.open.idtarefa !== null) {
         obj = this.props.open;
         obj.idformulario = obj.jsonpasso.formulario;
         if (obj.formulario.subformularios === undefined) {
            obj.formulario.subformularios = [];
         }
         AState.form = obj;
         this.setState(AState);
      } else {
         obj = newTarefaState;
         obj.formulario.subformularios = [];
         obj.formulario.opcao = null;
         AState.form = obj;
         this.setState(AState);
      }
      this.props.getAtendimentos("SELECIONAR", this.props.xappRouteParams, AState.form, this.props.parametros);
   }

   componentWillUnmount() {
      this.props.disableScreenLock(false);
   }

   handleChange = (event) => {
      const form = _.set({ ...this.state.form }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value);
      this.setState({ form });
   };

   handleFormulario = (ev) => {
      const { xappRouteParams, saveTarefa } = this.props;
      var obj = this.state.form;
      obj.formulario[ev.target.name] = ev.target.value;
      this.setState({ form: obj });
      obj.acao = 121;
      saveTarefa(obj, xappRouteParams);
   };

   onClose = () => {
      this.props.openDialog(null);
      this.props.listFilter();
   };

   canBeSubmitted = () => {
      return true;
   };

   handleChangeTab = (ev, value) => {
      this.setState({ tabValue: value });
   };

   getNextStep = (_AID) => {
      const { getTarefa, xappRouteParams, parametros } = this.props;
      getTarefa(_AID, xappRouteParams, parametros);
   };

   canPrintHeader = (xappRouteParams, user) => {
      var AResponse = 0;
      if (!_.isUndefined(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao)) {
         let AConfig = _.find(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao, { "chave": "IMPRIMIR_CABECALHO_ATENDIMENTO" });
         if (!_.isUndefined(AConfig)) {
            AResponse = 1;
         }
      }
      return AResponse;
   };

   canPrintFooter = (xappRouteParams, user) => {
      var AResponse = 0;
      if (!_.isUndefined(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao)) {
         let AConfig = _.find(user.settings.sistemas[xappRouteParams.empresa].dados.configuracao, { "chave": "IMPRIMIR_RODAPE_ATENDIMENTO" });
         if (!_.isUndefined(AConfig)) {
            AResponse = 1;
         }
      }
      return AResponse;
   };

   render() {
      const { classes, xappRouteParams, listFilter, settings, readOnly, TagsFormulario, parametros, open, user } = this.props;
      const { tabValue, form, showNavbar } = this.state;
      var canPrintHeader = this.canPrintHeader(xappRouteParams, user);
      var canPrintFooter = this.canPrintFooter(xappRouteParams, user);

      return (
         <React.Fragment>
            <XAPPDialog
               id="Atendimento"
               open={open !== null}
               onClose={this.onClose}
               fullWidth
               fullScreen
               className="overflow-hidden"
            >
               <div />
               <AppBar position="static" elevation={1}>
                  <Toolbar className={clsx(classes.toolbarDialog, "flex w-full")}>
                     <Typography variant="subtitle1 text-white">
                        {open.jsonpasso && open.obj.inicio + " - " + open.jsonpasso.titulo}
                     </Typography>
                     <div style={{ flex: 1 }} />
                     <XAPPButton
                        id="iconFecharAtendimento"
                        type="icon"
                        onClick={this.onClose}
                        icon={"close"}
                        iconProps={"text-20"}
                        className={"text-white text-20"}
                     />
                  </Toolbar>
               </AppBar>
               {form.formulario !== null && (
                  <DialogContent id="atendimentoDialogContent" className={"p-0 overflow-hidden"}>
                     <FusePageCarded
                        classes={{
                           header: clsx("", "h-fit min-h-px"),
                           toolbar: classes.toolbarPessoa,
                           leftSidebar: "w-fit",
                           sidebarHeader: "h-128 min-h-128",
                           topBg: classes.topBg,
                           contentWrapper: "p-0 overflow-hidden"
                        }}
                        header={
                           <React.Fragment>
                              <div className="flex w-full flex-row items-center">
                                 <XAPPButton
                                    type="Icon"
                                    className=""
                                    onClick={() => {
                                       if (_.isNull(md.mobile()) && _.isNull(md.tablet()))
                                          this.setState(_.set({ ...this.state }, "showNavbar", !showNavbar));
                                       else this.pageLayout.toggleLeftSidebar();
                                    }}
                                    iconProps={"justify-end"}
                                    icon={"list"}
                                    key={"iconOpenNavbar"}
                                 />
                                 <div className="flex-1" />
                                 {form.conclusao === null && <Cronometro color="textSecondary" className="mr-8 xs:text-18 sm:text-24" />}
                                 <div className="flex-1" />
                                 <div className="flex flex-row">
                                    <CompartilharDocumentos
                                       xappRouteParams={xappRouteParams}
                                       idpessoaformulario={form?.idpessoaformulario}
                                       idprofissional={form.obj?.idprofissional}
                                    />
                                    <Memed
                                       data={{ ...form.pessoaformulario, idpessoaformulario: form.idpessoaformulario }}
                                       idfuncionalidade={form.idtarefa}
                                       xappRouteParams={xappRouteParams}
                                       callbackSave={() => window.changeFormulario(100)}
                                       callbackRemove={() => { }}
                                    />
                                    {!_.isUndefined(form.obj) && !_.isUndefined(form.obj.webex) && !_.isNull(form.obj.webex) &&
                                       <WebexMeetingToogle />
                                    }
                                    <AgendamentoEdicaoApp
                                       xappRouteParams={xappRouteParams}
                                       callback={() => { }}
                                       view={"Oportunidade"}
                                       isDialog={true}
                                       key={"Agendamento_New_Oportunidade"}
                                       tipo={4}
                                       idagendamento={"new_Oportunidade"}
                                       sugerido={{
                                          clientes: [{ idpessoaformulario: form.idpessoaformulario, ...form.pessoaformulario }],
                                       }}
                                    >
                                       <XAPPButton
                                          tooltip={{ "title": "Adicionar oportunidade", "placement": "bottom" }}
                                          type="Icon"
                                          onClick={() => { }}
                                          icon={"lampada_flash"}
                                          iconProps={"text-20 "}
                                       />
                                    </AgendamentoEdicaoApp>
                                    {!_.isUndefined(form.obj) && (
                                       <MensagemAgendamento
                                          idfuncionalidade={form.obj.idagendamentopessoaformulario}
                                          xappRouteParams={xappRouteParams}
                                          className={clsx(classes.textColor, "text-18")}
                                          header={form.prazodescricao + " - " + form.pessoaformulario.nome}
                                       />
                                    )}
                                    {_.isUndefined(form.conclusao) || _.isNull(form.conclusao) &&
                                       <TagFormulario
                                          key={"TagFormularioFormulario"}
                                          tags={TagsFormulario}
                                          selected={form.formulario?.tags}
                                          target="tags"
                                          showSelected={false}
                                          onChange={this.handleFormulario}
                                          xappRouteParams={xappRouteParams}
                                          refreshTags={listFilter}
                                          tipo={"atendimento"}
                                          className="text-20"
                                       />
                                    }
                                 </div>
                              </div>
                           </React.Fragment>
                        }
                        content={
                           <React.Fragment>
                              {!_.isUndefined(form.obj) && !_.isUndefined(form.obj.webex) && !_.isNull(form.obj.webex) &&
                                 <Draggable disabled={!(_.isNull(md.mobile()) && _.isNull(md.tablet()))}>
                                    <div className="sm:h-0">
                                       <div className={clsx(classes.meeting, "xs:w-full w-fit bg-white")}>
                                          <WebexMeeting
                                             meetingDetails={form.obj.webex}
                                             xappRouteParams={xappRouteParams}
                                          />
                                       </div>
                                    </div>
                                 </Draggable>
                              }
                              <div className="h-full overflow-hidden" style={{ display: tabValue !== 0 && "none" }}>
                                 <DocumentoAtendimento
                                    canPrintHeader={canPrintHeader}
                                    canPrintFooter={canPrintFooter}
                                    xappRouteParams={xappRouteParams}
                                    idfuncionalidade={form.idtarefa}
                                    idpessoaformulario={form.idpessoaformulario}
                                    status={form.status}
                                    idagendamentopessoaformulario={form.obj?.idagendamentopessoaformulario}
                                    convenio={form.obj?.convenio}
                                 />
                              </div>
                              {!_.isNull(form.idtarefa) && tabValue === 0 &&
                                 <ArquivoApp
                                    xappRouteParams={xappRouteParams}
                                    idfuncionalidade={form.idtarefa}
                                    campofuncionalidade={"idtarefa"}
                                    tipo={1}
                                    showRemover={true}
                                    showListagem={false}
                                 />
                              }
                              {!_.isNull(form.idtarefa) && tabValue === 3 && (
                                 <div className="p-16">
                                    <TextField
                                       className="mt-16"
                                       label="Observações"
                                       id="observacao"
                                       name="observacao"
                                       value={form.observacao}
                                       onChange={this.handleChange}
                                       variant="outlined"
                                       fullWidth
                                       multiline
                                       rows={10}
                                       readOnly={readOnly || form.conclusao !== null}
                                       InputLabelProps={{
                                          shrink: true,
                                       }}
                                    />
                                 </div>
                              )}
                              {!_.isNull(form.idtarefa) && tabValue === 4 &&
                                 <ArquivoApp
                                    xappRouteParams={xappRouteParams}
                                    idfuncionalidade={form.idpessoaformulario}
                                    campofuncionalidade={"idpessoaformulario"}
                                    tipo={1}
                                    showRemover={true}
                                 />
                              }
                              {!_.isNull(form.idtarefa) && tabValue === 5 &&
                                 <GaleriaApp
                                    xappRouteParams={xappRouteParams}
                                    idfuncionalidade={form.idpessoaformulario}
                                    campofuncionalidade={"idpessoaformulario"}
                                    tipo={1}
                                    listar={true}
                                    showRemover={true}
                                 />
                              }
                              {!_.isNull(form.idtarefa) && tabValue === 9 && (
                                 <EmpresaPessoaFormularioApp
                                    xappRouteParams={xappRouteParams}
                                    idparent={form.idpessoaformulario}
                                 />
                              )}
                              {!_.isNull(form.idtarefa) && tabValue === 1 && (
                                 <CustomCrmForm
                                    xappRouteParams={xappRouteParams}
                                    data={{ ...form.pessoaformulario, idpessoaformulario: form.idpessoaformulario }}
                                    settings={settings}
                                 />
                              )}
                              {!_.isNull(form.idtarefa) && tabValue === 2 && (
                                 <TarefaApontamentoPedidoEmAberto
                                    xappRouteParams={xappRouteParams}
                                    idtarefaprocesso={form.idtarefaprocesso}
                                    idpessoaformulario={form.idpessoaformulario}
                                    readOnly={true}
                                 />
                              )}
                           </React.Fragment>
                        }
                        leftSidebarContent={
                           showNavbar && (
                              <AtendimentoNavbar
                                 tabValue={tabValue}
                                 handleChangeTab={this.handleChangeTab}
                                 xappRouteParams={xappRouteParams}
                                 settings={settings}
                              />
                           )
                        }
                        onRef={(instance) => {
                           this.pageLayout = instance;
                        }}
                        sidebarInner
                        innerScroll
                     />
                  </DialogContent>
               )}
               {tabValue === 0 &&
                  <AppBar position="static" elevation={3} color="textSecondary">
                     <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions className="gap-6">
                           {_.isUndefined(form.conclusao) || _.isNull(form.conclusao) ? (
                              <GerenciadorProcessoApp
                                 Tarefa={form}
                                 passofluxo={form.passofluxo}
                                 xappRouteParams={xappRouteParams}
                                 getNext={this.getNextStep}
                                 close={this.onClose}
                                 canBeSubmitted={this.canBeSubmitted}
                                 parametros={parametros}
                              />
                           ) : (
                              <XAPPButton
                                 type="Button"
                                 className="mr-12"
                                 variant="contained"
                                 color="primary"
                                 onClick={() => {
                                    this.props.saveTarefa(form, xappRouteParams);
                                 }}
                                 iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                 icon={"save"}
                                 label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                              />
                           )}
                        </DialogActions>
                     </Toolbar>
                  </AppBar>
               }
            </XAPPDialog>
         </React.Fragment>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators(
      {
         getTarefa: Actions.getTarefa,
         saveTarefa: Actions.saveTarefa,
         getAtendimentos: Actions.getAtendimentos,
         clearAtendimentos: Actions.clearAtendimentos,
         disableScreenLock: disableScreenLock,
      },
      dispatch
   );
}

function mapStateToProps({ MinhasTarefas, auth }) {
   return {
      TagsTarefa: MinhasTarefas.TagFuncionalidadeReducer["agendamento"],
      TagsFormulario: MinhasTarefas.TagFuncionalidadeReducer["atendimento"],
      user: auth.user.data,
      settings: auth.user.data.settings,
   };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(AtendimentoDialog)));
